import DocumentList from "../../views/modules/Development/documents/DocumentsList";
import development from "../../views/modules/Development/development";
import layouts from "../../layout";

export default {
  path: "/development",
  name: "development",
  component: development,
  meta: {
    auth: true
  },
  redirect: {
    name: "Development-document"
  },
  children: [
    {
      path: "documents",
      name: "Development-document",
      component: DocumentList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Documents",
        tags: ["development", "documents"],
        index: true
      }
    }
  ]
};
